import lazyLoading from './lazyLoading'

export default {
  name: 'monitor',
  path: '/maps/DriverMonitor',
  // component: lazyLoading('monitor/leaflet-maps/LeafletMapsPage'),
  component: lazyLoading('monitor/google-maps/GoogleMapsPage'),
  meta: {
    default: false,
    title: 'Monitoreo',
    iconClass: 'va-icon entypo entypo-monitor',
    requiresAuth: true
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/monitor.js